/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthCalibrationRouteImport } from './routes/_auth/calibration'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AuthClustersIndexRouteImport } from './routes/_auth/clusters/index'
import { Route as AuthClustersIdRouteImport } from './routes/_auth/clusters/$id'
import { Route as AuthExperimentsIndexRouteImport } from './routes/_auth/experiments/index'
import { Route as AuthExperimentsIdRouteImport } from './routes/_auth/experiments/$id'
import { Route as AuthOpportunitiesIndexRouteImport } from './routes/_auth/opportunities/index'
import { Route as AuthOpportunitiesIdRouteImport } from './routes/_auth/opportunities/$id'
import { Route as AuthScansIndexRouteImport } from './routes/_auth/scans/index'
import { Route as AuthScansIdRouteImport } from './routes/_auth/scans/$id'
import { Route as AuthScansNewRouteImport } from './routes/_auth/scans/new'
import { Route as AuthSeedsIndexRouteImport } from './routes/_auth/seeds/index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth/settings/index'
import { Route as AuthSettingsAccountRouteImport } from './routes/_auth/settings/account'
import { Route as AuthSettingsBudgetRouteImport } from './routes/_auth/settings/budget'
import { Route as AuthSettingsCostsRouteImport } from './routes/_auth/settings/costs'
import { Route as AuthSettingsExclusionsRouteImport } from './routes/_auth/settings/exclusions'
import { Route as AuthSettingsScoringRouteImport } from './routes/_auth/settings/scoring'
import { Route as AuthSettingsUsersRouteImport } from './routes/_auth/settings/users'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCalibrationRoute = AuthCalibrationRouteImport.update({
  id: '/calibration',
  path: '/calibration',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthClustersIndexRoute = AuthClustersIndexRouteImport.update({
  id: '/clusters/',
  path: '/clusters/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClustersIdRoute = AuthClustersIdRouteImport.update({
  id: '/clusters/$id',
  path: '/clusters/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthExperimentsIndexRoute = AuthExperimentsIndexRouteImport.update({
  id: '/experiments/',
  path: '/experiments/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthExperimentsIdRoute = AuthExperimentsIdRouteImport.update({
  id: '/experiments/$id',
  path: '/experiments/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOpportunitiesIndexRoute = AuthOpportunitiesIndexRouteImport.update({
  id: '/opportunities/',
  path: '/opportunities/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOpportunitiesIdRoute = AuthOpportunitiesIdRouteImport.update({
  id: '/opportunities/$id',
  path: '/opportunities/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScansIndexRoute = AuthScansIndexRouteImport.update({
  id: '/scans/',
  path: '/scans/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScansIdRoute = AuthScansIdRouteImport.update({
  id: '/scans/$id',
  path: '/scans/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthScansNewRoute = AuthScansNewRouteImport.update({
  id: '/scans/new',
  path: '/scans/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSeedsIndexRoute = AuthSeedsIndexRouteImport.update({
  id: '/seeds/',
  path: '/seeds/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsAccountRoute = AuthSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsBudgetRoute = AuthSettingsBudgetRouteImport.update({
  id: '/budget',
  path: '/budget',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsCostsRoute = AuthSettingsCostsRouteImport.update({
  id: '/costs',
  path: '/costs',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsExclusionsRoute = AuthSettingsExclusionsRouteImport.update({
  id: '/exclusions',
  path: '/exclusions',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsScoringRoute = AuthSettingsScoringRouteImport.update({
  id: '/scoring',
  path: '/scoring',
  getParentRoute: () => AuthSettingsRoute,
} as any)
const AuthSettingsUsersRoute = AuthSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/calibration': typeof AuthCalibrationRoute
  '/settings': typeof AuthSettingsRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/clusters/$id': typeof AuthClustersIdRoute
  '/experiments/$id': typeof AuthExperimentsIdRoute
  '/opportunities/$id': typeof AuthOpportunitiesIdRoute
  '/scans/$id': typeof AuthScansIdRoute
  '/scans/new': typeof AuthScansNewRoute
  '/settings/account': typeof AuthSettingsAccountRoute
  '/settings/budget': typeof AuthSettingsBudgetRoute
  '/settings/costs': typeof AuthSettingsCostsRoute
  '/settings/exclusions': typeof AuthSettingsExclusionsRoute
  '/settings/scoring': typeof AuthSettingsScoringRoute
  '/settings/users': typeof AuthSettingsUsersRoute
  '/clusters/': typeof AuthClustersIndexRoute
  '/experiments/': typeof AuthExperimentsIndexRoute
  '/opportunities/': typeof AuthOpportunitiesIndexRoute
  '/scans/': typeof AuthScansIndexRoute
  '/seeds/': typeof AuthSeedsIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/calibration': typeof AuthCalibrationRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AuthIndexRoute
  '/clusters/$id': typeof AuthClustersIdRoute
  '/experiments/$id': typeof AuthExperimentsIdRoute
  '/opportunities/$id': typeof AuthOpportunitiesIdRoute
  '/scans/$id': typeof AuthScansIdRoute
  '/scans/new': typeof AuthScansNewRoute
  '/settings/account': typeof AuthSettingsAccountRoute
  '/settings/budget': typeof AuthSettingsBudgetRoute
  '/settings/costs': typeof AuthSettingsCostsRoute
  '/settings/exclusions': typeof AuthSettingsExclusionsRoute
  '/settings/scoring': typeof AuthSettingsScoringRoute
  '/settings/users': typeof AuthSettingsUsersRoute
  '/clusters': typeof AuthClustersIndexRoute
  '/experiments': typeof AuthExperimentsIndexRoute
  '/opportunities': typeof AuthOpportunitiesIndexRoute
  '/scans': typeof AuthScansIndexRoute
  '/seeds': typeof AuthSeedsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/calibration': typeof AuthCalibrationRoute
  '/_auth/settings': typeof AuthSettingsRouteWithChildren
  '/invite/$token': typeof InviteTokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/clusters/$id': typeof AuthClustersIdRoute
  '/_auth/experiments/$id': typeof AuthExperimentsIdRoute
  '/_auth/opportunities/$id': typeof AuthOpportunitiesIdRoute
  '/_auth/scans/$id': typeof AuthScansIdRoute
  '/_auth/scans/new': typeof AuthScansNewRoute
  '/_auth/settings/account': typeof AuthSettingsAccountRoute
  '/_auth/settings/budget': typeof AuthSettingsBudgetRoute
  '/_auth/settings/costs': typeof AuthSettingsCostsRoute
  '/_auth/settings/exclusions': typeof AuthSettingsExclusionsRoute
  '/_auth/settings/scoring': typeof AuthSettingsScoringRoute
  '/_auth/settings/users': typeof AuthSettingsUsersRoute
  '/_auth/clusters/': typeof AuthClustersIndexRoute
  '/_auth/experiments/': typeof AuthExperimentsIndexRoute
  '/_auth/opportunities/': typeof AuthOpportunitiesIndexRoute
  '/_auth/scans/': typeof AuthScansIndexRoute
  '/_auth/seeds/': typeof AuthSeedsIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/calibration'
    | '/settings'
    | '/invite/$token'
    | '/clusters/$id'
    | '/experiments/$id'
    | '/opportunities/$id'
    | '/scans/$id'
    | '/scans/new'
    | '/settings/account'
    | '/settings/budget'
    | '/settings/costs'
    | '/settings/exclusions'
    | '/settings/scoring'
    | '/settings/users'
    | '/clusters/'
    | '/experiments/'
    | '/opportunities/'
    | '/scans/'
    | '/seeds/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/calibration'
    | '/invite/$token'
    | '/'
    | '/clusters/$id'
    | '/experiments/$id'
    | '/opportunities/$id'
    | '/scans/$id'
    | '/scans/new'
    | '/settings/account'
    | '/settings/budget'
    | '/settings/costs'
    | '/settings/exclusions'
    | '/settings/scoring'
    | '/settings/users'
    | '/clusters'
    | '/experiments'
    | '/opportunities'
    | '/scans'
    | '/seeds'
    | '/settings'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/reset-password'
    | '/_auth/calibration'
    | '/_auth/settings'
    | '/invite/$token'
    | '/_auth/'
    | '/_auth/clusters/$id'
    | '/_auth/experiments/$id'
    | '/_auth/opportunities/$id'
    | '/_auth/scans/$id'
    | '/_auth/scans/new'
    | '/_auth/settings/account'
    | '/_auth/settings/budget'
    | '/_auth/settings/costs'
    | '/_auth/settings/exclusions'
    | '/_auth/settings/scoring'
    | '/_auth/settings/users'
    | '/_auth/clusters/'
    | '/_auth/experiments/'
    | '/_auth/opportunities/'
    | '/_auth/scans/'
    | '/_auth/seeds/'
    | '/_auth/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/calibration': {
      id: '/_auth/calibration'
      path: '/calibration'
      fullPath: '/calibration'
      preLoaderRoute: typeof AuthCalibrationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/clusters/': {
      id: '/_auth/clusters/'
      path: '/clusters'
      fullPath: '/clusters/'
      preLoaderRoute: typeof AuthClustersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clusters/$id': {
      id: '/_auth/clusters/$id'
      path: '/clusters/$id'
      fullPath: '/clusters/$id'
      preLoaderRoute: typeof AuthClustersIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/experiments/': {
      id: '/_auth/experiments/'
      path: '/experiments'
      fullPath: '/experiments/'
      preLoaderRoute: typeof AuthExperimentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/experiments/$id': {
      id: '/_auth/experiments/$id'
      path: '/experiments/$id'
      fullPath: '/experiments/$id'
      preLoaderRoute: typeof AuthExperimentsIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/opportunities/': {
      id: '/_auth/opportunities/'
      path: '/opportunities'
      fullPath: '/opportunities/'
      preLoaderRoute: typeof AuthOpportunitiesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/opportunities/$id': {
      id: '/_auth/opportunities/$id'
      path: '/opportunities/$id'
      fullPath: '/opportunities/$id'
      preLoaderRoute: typeof AuthOpportunitiesIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scans/': {
      id: '/_auth/scans/'
      path: '/scans'
      fullPath: '/scans/'
      preLoaderRoute: typeof AuthScansIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scans/$id': {
      id: '/_auth/scans/$id'
      path: '/scans/$id'
      fullPath: '/scans/$id'
      preLoaderRoute: typeof AuthScansIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/scans/new': {
      id: '/_auth/scans/new'
      path: '/scans/new'
      fullPath: '/scans/new'
      preLoaderRoute: typeof AuthScansNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/seeds/': {
      id: '/_auth/seeds/'
      path: '/seeds'
      fullPath: '/seeds/'
      preLoaderRoute: typeof AuthSeedsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/account': {
      id: '/_auth/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthSettingsAccountRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/budget': {
      id: '/_auth/settings/budget'
      path: '/budget'
      fullPath: '/settings/budget'
      preLoaderRoute: typeof AuthSettingsBudgetRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/costs': {
      id: '/_auth/settings/costs'
      path: '/costs'
      fullPath: '/settings/costs'
      preLoaderRoute: typeof AuthSettingsCostsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/exclusions': {
      id: '/_auth/settings/exclusions'
      path: '/exclusions'
      fullPath: '/settings/exclusions'
      preLoaderRoute: typeof AuthSettingsExclusionsRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/scoring': {
      id: '/_auth/settings/scoring'
      path: '/scoring'
      fullPath: '/settings/scoring'
      preLoaderRoute: typeof AuthSettingsScoringRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
    '/_auth/settings/users': {
      id: '/_auth/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthSettingsUsersRouteImport
      parentRoute: typeof AuthSettingsRoute
    }
  }
}

interface AuthSettingsRouteChildren {
  AuthSettingsAccountRoute: typeof AuthSettingsAccountRoute
  AuthSettingsBudgetRoute: typeof AuthSettingsBudgetRoute
  AuthSettingsCostsRoute: typeof AuthSettingsCostsRoute
  AuthSettingsExclusionsRoute: typeof AuthSettingsExclusionsRoute
  AuthSettingsScoringRoute: typeof AuthSettingsScoringRoute
  AuthSettingsUsersRoute: typeof AuthSettingsUsersRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
}

const AuthSettingsRouteChildren: AuthSettingsRouteChildren = {
  AuthSettingsAccountRoute: AuthSettingsAccountRoute,
  AuthSettingsBudgetRoute: AuthSettingsBudgetRoute,
  AuthSettingsCostsRoute: AuthSettingsCostsRoute,
  AuthSettingsExclusionsRoute: AuthSettingsExclusionsRoute,
  AuthSettingsScoringRoute: AuthSettingsScoringRoute,
  AuthSettingsUsersRoute: AuthSettingsUsersRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
}

const AuthSettingsRouteWithChildren = AuthSettingsRoute._addFileChildren(
  AuthSettingsRouteChildren,
)

interface AuthRouteChildren {
  AuthCalibrationRoute: typeof AuthCalibrationRoute
  AuthSettingsRoute: typeof AuthSettingsRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthClustersIdRoute: typeof AuthClustersIdRoute
  AuthExperimentsIdRoute: typeof AuthExperimentsIdRoute
  AuthOpportunitiesIdRoute: typeof AuthOpportunitiesIdRoute
  AuthScansIdRoute: typeof AuthScansIdRoute
  AuthScansNewRoute: typeof AuthScansNewRoute
  AuthClustersIndexRoute: typeof AuthClustersIndexRoute
  AuthExperimentsIndexRoute: typeof AuthExperimentsIndexRoute
  AuthOpportunitiesIndexRoute: typeof AuthOpportunitiesIndexRoute
  AuthScansIndexRoute: typeof AuthScansIndexRoute
  AuthSeedsIndexRoute: typeof AuthSeedsIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCalibrationRoute: AuthCalibrationRoute,
  AuthSettingsRoute: AuthSettingsRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthClustersIdRoute: AuthClustersIdRoute,
  AuthExperimentsIdRoute: AuthExperimentsIdRoute,
  AuthOpportunitiesIdRoute: AuthOpportunitiesIdRoute,
  AuthScansIdRoute: AuthScansIdRoute,
  AuthScansNewRoute: AuthScansNewRoute,
  AuthClustersIndexRoute: AuthClustersIndexRoute,
  AuthExperimentsIndexRoute: AuthExperimentsIndexRoute,
  AuthOpportunitiesIndexRoute: AuthOpportunitiesIndexRoute,
  AuthScansIndexRoute: AuthScansIndexRoute,
  AuthSeedsIndexRoute: AuthSeedsIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
